import adminSaga from "./admin/adminSaga";
import attachmentsSaga from "./attachments/attachmentsSaga";
import imagesSaga from "./images/imagesSaga";
import staticDataSaga from "./staticData/staticDataSaga";
import { spawn } from "redux-saga/effects";

export default function* tempSaga() {
  yield spawn(imagesSaga);
  yield spawn(attachmentsSaga);
  yield spawn(staticDataSaga);
  yield spawn(adminSaga);
}
